var map = {
	"./1.png": 363,
	"./10.png": 483,
	"./11.png": 826,
	"./12.png": 833,
	"./13.png": 80,
	"./14.png": 951,
	"./15.png": 206,
	"./16.png": 621,
	"./17.png": 492,
	"./18.png": 787,
	"./2.png": 504,
	"./3.png": 369,
	"./4.png": 630,
	"./5.png": 119,
	"./6.png": 116,
	"./7.png": 381,
	"./8.png": 530,
	"./9.png": 355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 565;